﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const operational_context_client_1 = require("@its-suite/operational-context-client");
const BaseSettingsConversion_1 = require("./BaseSettingsConversion");
exports.SYSTEM_SETTINGS_DEFAULT_SETTINGS = {
    visibilityBetweenOrganizationsEnabled: false,
    vehicleSharingEnabled: false,
    dutiesEnabled: false
};
class SystemSettingsConversion extends BaseSettingsConversion_1.BaseSettingsConversion {
    static convert(settings) {
        return {
            visibilityBetweenOrganizationsEnabled: this.getBooleanValue(settings.settingItems, operational_context_client_1.SystemSettingsKeys[operational_context_client_1.SystemSettingsKeys.VisibilityBetweenOrganizationsEnabled], exports.SYSTEM_SETTINGS_DEFAULT_SETTINGS.visibilityBetweenOrganizationsEnabled),
            vehicleSharingEnabled: this.getBooleanValue(settings.settingItems, operational_context_client_1.SystemSettingsKeys[operational_context_client_1.SystemSettingsKeys.VehicleSharingEnabled], exports.SYSTEM_SETTINGS_DEFAULT_SETTINGS.vehicleSharingEnabled),
            dutiesEnabled: this.getBooleanValue(settings.settingItems, operational_context_client_1.SystemSettingsKeys[operational_context_client_1.SystemSettingsKeys.DutiesEnabled], exports.SYSTEM_SETTINGS_DEFAULT_SETTINGS.dutiesEnabled)
        };
    }
}
exports.SystemSettingsConversion = SystemSettingsConversion;
//# sourceMappingURL=SystemSettingsConversion.js.map